const MONTH_NAMES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export function parseEventDateValue(value?: string | null): Date | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const dateOnlyPattern = /^(\d{4})-(\d{2})-(\d{2})$/;
  const match = trimmed.match(dateOnlyPattern);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
      return null;
    }
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return parsed;
}

export function formatEventDateTime(input?: Date | string | null): string {
  const date =
    input instanceof Date
      ? input
      : typeof input === 'string'
        ? parseEventDateValue(input)
        : null;

  if (!date) return '';

  const day = date.getDate();
  const monthName = MONTH_NAMES[date.getMonth()] ?? '';
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day} de ${monthName}, ${year} - ${hours}:${minutes}hs`;
}
